<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="商品品牌"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <!--  <el-row v-if="$permission.isStore()==false"> 总部用户，显示门店名称下拉给选择，可以为某个门店录入数据
            <el-col :span="isMB?24:12">
              <el-form-item label="门店名称" prop="BrandCountry">
                <el-input v-model="data.BrandCountry" placeholder="请选择门店名称" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>   -->
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="品牌名称" prop="BrandName">
              <el-input
                v-model="data.BrandName"
                placeholder="请填写品牌名称"
                clearable
                v-if="!showBrand"
              ></el-input>
              <el-select
                v-model="data.BrandId"
                @change="selectBrand"
                filterable
                clearable
                v-else
              >
                <el-option
                  v-for="(item, index) in brands"
                  :key="index"
                  :value="item.BrandId"
                  :label="item.BrandName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="isMB?24:12" v-if="data.RecordId==0">
             <div style="padding-left:10px"> <el-button size="mini" type="success" @click="changeBrand">引用平台品牌</el-button></div>
            </el-col> -->
          <!-- <el-col :span="24">
            <el-form-item label="商品一级类别">
              <el-select v-model="arr2" placeholder="请选择一级分类" multiple clearable>
                <el-option v-for="(item,index) in typeList" :key="index" :value="item.RecordId" :label="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
            </el-col> -->
        </el-row>

        <!-- <el-row>
               <el-col :span="isMB ? 24 : 12">
            
            <el-form-item label="品牌国家" prop="CountryId">
              <el-select v-model="data.CountryId" placeholder="请选择品牌国家" clearable>
                  <el-option v-for="(i, k) in Countrys" :key="k" :label="i.CountryCode+i.CountryName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col> 
             
          </el-row> -->

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import storeSelect from "@/components/shop/store/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    storeSelect,
  },
  mounted() {},
  data() {
    return {
      data: {
        RecordId: 0,
        BrandName: "",
        OrderId: 0,
        State: 1,
        DataSource: 0,
        CountryId: null,
        BrandId: null,
        UserType: null,
        StoreId: null,
      },
      list: [],
      brands: [
        {
          RecordId: 0,
          // OrderId: 0,
          BrandName: "",

          State: 0,
        },
      ],
      place: [],
      arr2: [],
      api: require("@/api/goods/brand").default,
      country_api: require("@/api/sy/country").default,
      api2: require("@/api/goods/brandplatform").default,
      api3: require("@/api/shop/store").default,
      uploadUrl: "/api/Common/UploadPicture",
      isMB: this.$store.state.isMB,
      rules: {
        BrandName: [{ required: true, message: "品牌名称不能为空" }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      Countrys: [],
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属门店" }],
      },
      showBrand: false,
      stores: [
        {
          RecordId: 0,
          StoreName: "",
        },
      ],
    };
  },
  mounted() {
    this.country_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Countrys = res.Data;
      }
    });
  },
  methods: {
    selectStore(e) {
      var store = this.stores.filter((x) => x.RecordId == e)[0];
      this.data.StoreId = store.RecordId;
      // this.api.getMaxOrderId(store.RecordId).then(res => {
      //  if(res.Code==0) this.data.OrderId = res.Data;
      // })
    },
    selectBrand(e) {
      var brand = this.brands.filter((x) => x.RecordId == e)[0];
      this.data.BrandName = brand.BrandName;
      this.data.CountryId = brand.CountryId;
      this.data.DataSource = 1;
      this.data.RecordId = 0;
    },
    changeBrand() {
      this.showBrand = true;
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(data) {
      this.getOption();
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.brands = res.Data;
          this.brands.forEach((item) => {
            item.BrandId = item.RecordId;
          });
        }
      });
      this.api3.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.stores = res.Data;
          this.stores.forEach((item) => {
            item.StoreId = item.RecordId;
          });
        }
      });
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));

      if (!this.$permission.isStore() && !data.StoreId) {
        this.$message.error("请选择所属门店");
        return false;
      }

      data = this.$commonJs.obj.removeNullKey(data); //这个的作用是移除里面的null字段，有些接口参数传null会报错。

      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.arr2 = [];
      this.data.Brandtypes = [];
      this.brands = [];
      this.place = [];
      this.showBrand = false;
    },
  },
};
</script>